/**
 * Overrides Service
 * Handles overrides report data fetching
 */

import { IS_MOCK, MOCK_DELAY } from '../../constants/config';
import { generateMockOverridesData } from '../mock/mockOverrides';
import { delay } from '../mock/mockData';
import type { OverrideData, ReportFilters } from '../../types/reports';

class OverridesService {
  /**
   * Get overrides report data
   */
  static async getOverridesData(
    filters?: ReportFilters,
    page: number = 1,
    pageSize: number = 15
  ): Promise<OverrideData & { currentPage: number; totalPages: number }> {
    if (IS_MOCK) {
      await delay(MOCK_DELAY / 2);
      const data = generateMockOverridesData();
      const totalPages = Math.ceil(data.totalEntries / pageSize);
      
      return {
        ...data,
        currentPage: page,
        totalPages,
      };
    } else {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
      });
      
      if (filters?.dateRange) params.append('dateRange', filters.dateRange);
      if (filters?.missionType) params.append('missionType', filters.missionType);
      if (filters?.adminUser) params.append('adminUser', filters.adminUser);
      
      const response = await fetch(`/api/reports/overrides?${params.toString()}`);
      if (!response.ok) {
        throw new Error('Failed to fetch overrides data');
      }
      return response.json();
    }
  }
}

export { OverridesService };

